<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список брендов</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование бренда</li>
        </ol>
    </nav>

    <div class="col-md-4 col-12">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="brand-name">Клиент <span class="color-red">*</span></label>
                <v-select
                    id="input_name_client_id"
                    v-model="clientId"
                    :items="clients"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="brand-name">Название бренда <span class="color-red">*</span></label>
                <input type="text" class="form-control" id="brand-name" v-model="name" placeholder="Введите название бренда">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="brand-img">Логотип бренда</label>
                <input type="text" class="form-control" id="brand-img" v-model="img" placeholder="Введите логотип бренда">
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="updateBrand"/>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>
</template>

<script>
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Brand from "../../../../models/Brand";

export default {
    name: "BrandEditComponent",
    components: { ConfirmBtn },
    props: {
        route_back: String,
        route_get: String,
        route_update: String,
        route_client_search: String,
        brand_id: {
            type: [Number, String],
        }
    },
    data: function () {
       return {
           brand: new Brand({
               route_update: this.route_update,
               route_get: this.route_get,
               route_client_search: this.route_client_search,
           }),
           name: '',
           img: '',
           clientId: null,
           clients: []
       }
    },
    methods: {
        ...mapMutations('ui', ['toggleLoading']),
        updateBrand: async function () {
            let response = this.brand.update({
                name: this.name,
                img: this.img,
                client_id: this.clientId
            }, this.brand_id);

            if(response) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_brand');
                this.toggleLoading();
            }
        },
        itemGet: async function () {
            let item = await this.brand.get(this.brand_id);
            this.name = item.name;
            this.clientId = item.client_id;
            this.img = item.img;
        },
        getClients: async function () {
            let clients = await this.brand.clients();
            this.clients = clients.items;
        },
    },
    mounted() {
        this.itemGet();
        this.getClients();
    }
}
</script>

<style scoped>

</style>
